import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import {
  TrendingDownOutlined,
  PhonelinkEraseOutlined,
  VisibilityOffOutlined,
  PersonSearchOutlined,
} from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import SectionContainer from '../../components/SectionContainer';
import RevealOnScroll from '../../components/RevealOnScroll';

const PROBLEMS = [
  {
    Icon: TrendingDownOutlined,
    title: 'Crores wasted on ads',
    description: 'Lakhs burned on Google and Facebook clicks that never enrol.',
  },
  {
    Icon: PhonelinkEraseOutlined,
    title: 'Unqualified calls',
    description: 'Hours on callers who aren\'t serious, aren\'t ready, or aren\'t local.',
  },
  {
    Icon: VisibilityOffOutlined,
    title: 'Invisible against the giants',
    description: 'Competing with Byju\'s, Unacademy, PW for every keyword.',
  },
  {
    Icon: PersonSearchOutlined,
    title: 'Can\'t reach real aspirants',
    description: 'The students you want are studying — not scrolling ads.',
  },
];

function ProblemsSection() {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const orange = theme.palette.brand.orange.main;
  const golden = theme.palette.brand.golden.main;

  const cardBg = isDark
    ? 'rgba(27,54,93,0.6)'
    : theme.palette.background.paper;
  const cardBorder = isDark
    ? '1px solid rgba(255,255,255,0.08)'
    : '1px solid rgba(27,54,93,0.06)';

  return (
    <SectionContainer
      eyebrow="The institute owner's reality"
      title="Growing an institute is expensive."
      subtitle="Here's what we hear from coaching owners across India every week."
      sx={{
        background: isDark
          ? theme.palette.background.default
          : theme.palette.background.default,
      }}
    >
      <Grid container spacing={{ xs: 2, md: 3 }}>
        {PROBLEMS.map(({ Icon, title, description }, i) => (
          <Grid item xs={6} md={3} key={title}>
            <RevealOnScroll delay={i * 0.05}>
              <Box
                sx={{
                  p: { xs: 2.5, md: 3 },
                  borderRadius: '20px',
                  background: cardBg,
                  border: cardBorder,
                  height: '100%',
                  boxShadow: isDark
                    ? '0 4px 20px rgba(0,0,0,0.2)'
                    : '0 4px 20px rgba(27,54,93,0.06)',
                  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: isDark
                      ? '0 8px 32px rgba(0,0,0,0.3)'
                      : '0 8px 32px rgba(27,54,93,0.12)',
                  },
                }}
              >
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: '12px',
                    background: `linear-gradient(135deg, ${orange}22, ${golden}22)`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 2,
                  }}
                >
                  <Icon sx={{ color: orange, fontSize: 26 }} />
                </Box>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 700, color: 'text.primary', mb: 0.5, lineHeight: 1.3 }}
                >
                  {title}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
                  {description}
                </Typography>
              </Box>
            </RevealOnScroll>
          </Grid>
        ))}
      </Grid>
    </SectionContainer>
  );
}

export default ProblemsSection;
